import i18next from 'i18next'

export const renderLabel = (label: unknown, parseLabel: (label: unknown) => string) => {
    switch (label || '') {
        case 'other':
            return i18next.t('globals:values.other')
        case '':
        case 'unknown':
            return i18next.t('globals:values.unknown')
        default:
            return parseLabel(label)
    }
}
